import { type FileShareClient } from "@anna-money/anna-web-lib/api";
import { makeAutoObservable } from "mobx";
import { type AnalyticsManager } from "services/analytics/analyticsManager";

export class CompanyNameAnnexNOStore {
  private _annexNoFile?: File = undefined;
  private _fileId?: string = undefined;

  constructor(
    private readonly _fileShareClient: FileShareClient,
    private readonly _analyticsManager: AnalyticsManager,
  ) {
    makeAutoObservable(this);
  }

  get annexNoFile(): File | undefined {
    return this._annexNoFile;
  }

  set annexNoFile(value: File | undefined) {
    this._annexNoFile = value;
  }

  get fileId(): string | undefined {
    return this._fileId;
  }

  set fileId(value: string | undefined) {
    this._fileId = value;
  }

  async onChange(file: File): Promise<void> {
    if (!file) {
      this._analyticsManager.event("company-annex-error-no-file");
      this.annexNoFile = undefined;
      this.fileId = undefined;
      return;
    }

    try {
      const completeResponse = await this._fileShareClient.uploadFile(file);

      this.annexNoFile = file;
      this.fileId = completeResponse.id;
      this._analyticsManager.event("company-annex-approval-document", { file: completeResponse.id });
    } catch (e) {
      console.error(e);
      this._analyticsManager.event("fail-company-annex");
    }
  }
}
